module.exports = {"applyButtonText":"View season tickets","defaultPlaceholder":"Select"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/product-filter.json
// module id = 6NvN
// module chunks = 1